import { useSubscription } from 'urql';
import { UnreviewedCallErrorCountSubscription } from './graphql';

export function useUnreviewedCallErrorCount(organizationId: string | null) {
  const [{ data }] = useSubscription({
    query: UnreviewedCallErrorCountSubscription,
    variables: { organizationId: organizationId ?? '' },
    pause: !organizationId,
  });

  return data?.callErrorsAggregate.aggregate?.count ?? 0;
}
